import { FC, ReactNode } from 'react'
import { RiArrowRightSLine } from 'react-icons/ri'

import {
  List,
  MobileMenuFooter,
  StyledMobilMenu,
  SubMenuButton,
  UserCompanyName,
  UserName,
  UserInfoWrapper,
} from './MobilMenu.style'
import { MainNavigationType, SideBarDataType } from '../../../utils/constants/Navigation'

interface MobileMenuProps {
  activeSubIndex: number
  children?: ReactNode
  data: {
    mainNavigation: MainNavigationType
    subMenus: {
      [x: string]: SideBarDataType
    }
  }
  handler?: (path: string, index?: number) => void
  open: boolean
  pathname: string
  user: Record<string, any>
}

const MobilMenu: FC<MobileMenuProps> = ({
  activeSubIndex,
  children,
  data,
  handler,
  open,
  pathname,
  user,
}) => {
  if (!Array.isArray(data?.mainNavigation) || data?.mainNavigation?.length === 0) {
    return null
  }

  const onClick = (hasSubMenu: boolean, path: string, index?: number) => {
    if (hasSubMenu) {
      return
    }

    handler?.(path, index)
  }

  return (
    <StyledMobilMenu open={open}>
      <UserInfoWrapper>
        <UserName>{user?.fullName}</UserName>
        <UserCompanyName>{user?.tenant?.invoice?.companyTitle}</UserCompanyName>
      </UserInfoWrapper>
      <List>
        {data &&
          data.mainNavigation.map((item, index) => {
            if (item?.disabled) {
              return null
            }

            const subMenu = item?.path || '' in data?.subMenus ? data?.subMenus[item.path || ''] : []

            return (
              <details
                key={index}
                onClick={() => onClick(subMenu?.length > 0, item?.path || '')}
                {...(pathname === item?.path && { open })}
              >
                <summary>
                  {item?.icon || null}
                  <span>{item.text}</span>
                  <div>
                    <RiArrowRightSLine size={20} />
                  </div>
                </summary>
                {subMenu?.length > 0 && (
                  <section>
                    {subMenu.map((subItem, subIndex) => {
                      return (
                        <SubMenuButton
                          active={(activeSubIndex || 0) === subIndex}
                          key={subIndex}
                          onClick={() => {
                            onClick(false, item.path || '', subIndex)
                          }}
                        >
                          {subItem?.text}
                        </SubMenuButton>
                      )
                    })}
                  </section>
                )}
              </details>
            )
          })}
      </List>
      <MobileMenuFooter>{children}</MobileMenuFooter>
    </StyledMobilMenu>
  )
}

export default MobilMenu
